//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../no/Builder.js";
import "../Features/Features.AECDesign.BaseLibraryItemBuilderList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[1,"LibraryItemList",0,"Features.AECDesign.BaseLibraryItemBuilderList",0]],[[[],"CreateMaterialLayerDetailBuilder",{R_:{layerItem:"Features.AECDesign.MaterialLayerDetailBuilder"}},0,0],[[],"CreateMaterialSectionDetailBuilder",{R_:{sectionItem:"Features.AECDesign.MaterialSectionDetailBuilder"}},0,0],[[],"CreateMaterialStairDetailBuilder",{R_:{stairItem:"Features.AECDesign.MaterialStairDetailBuilder"}},0,0],[[],"CreateMaterialRailingDetailBuilder",{R_:{railingItem:"Features.AECDesign.MaterialRailingDetailBuilder"}},0,0],[[],"CreateMaterialDataContainerBuilder",{R_:{dataContainerItem:"Features.AECDesign.MaterialDataContainerBuilder"}},0,0],[["filePath"],"ImportToBuilder",{},1,0],[["filePath","caterory"],"MergeCategoryFromXML",{},2,0],[["filePath"],"ExportFromBuilder",{},1,0],[["identifier"],"Find",{R_:{found:"TaggedObject"}},1,0]],[]];
SPLM.Features.AECDesign.LibraryManagerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.LibraryManagerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;